import React from 'react';

const Background: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1278.09 525">
      <path
        fill="#fff"
        opacity=".4"
        d="M1276.19,303.26c1.05-.5,1.9-1.86,1.9-3.02v-75.49c0-1.16-.86-2.52-1.9-3.02L813.18.19c-1.05-.5-1.9.04-1.9,1.2v77.41c0,1.16.86,2.52,1.9,3.02l374.98,179.43c.69.32,1.31.61,1.31,1.26s-.62.93-1.31,1.26l-374.98,179.43c-1.05.5-1.9,1.86-1.9,3.02v77.41c0,1.16.86,1.7,1.9,1.2l463.01-221.55Z"
      />
      <path
        fill="#fff"
        opacity=".25"
        d="M870.55,303.26c1.05-.5,1.9-1.86,1.9-3.02v-75.49c0-1.16-.86-2.52-1.9-3.02L407.54.19c-1.05-.5-1.9.04-1.9,1.2v77.41c0,1.16.86,2.52,1.9,3.02l374.98,179.43c.69.32,1.31.61,1.31,1.26s-.62.93-1.31,1.26l-374.98,179.43c-1.05.5-1.9,1.86-1.9,3.02v77.41c0,1.16.86,1.7,1.9,1.2l463.01-221.55Z"
      />
      <path
        fill="#fff"
        opacity=".1"
        d="M464.91,303.26c1.05-.5,1.9-1.86,1.9-3.02v-75.49c0-1.16-.86-2.52-1.9-3.02L1.9.19C.86-.31,0,.23,0,1.39v77.41c0,1.16.86,2.52,1.9,3.02l374.98,179.43c.69.32,1.31.61,1.31,1.26s-.62.93-1.31,1.26L1.9,443.19c-1.05.5-1.9,1.86-1.9,3.02v77.41c0,1.16.86,1.7,1.9,1.2l463.01-221.55Z"
      />
    </svg>
  );
};

export default Background;
